import "../styles/globals.css";
import "../styles/fonts.css";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import ErrorBoundary from "../components/ErrorBoundary";
import { HeaderContext } from '../contexts/headerContext';


function MyApp({ Component, pageProps, router }) {
  const query = router.query;
  const authorizationParames = `apiKey=${query.apiKey}&version=${query.version}&deviceId=${query.deviceId}&oculusOrgId=${query.oculusOrgId}&oculusAccessToken=${query.oculusAccessToken}`;
  const isDev = process.env.NODE_ENV === "development";

  const [headerInfo, setHeaderInfo] = useState({ header: {} });

  useEffect(() => {
    const handleRouteChange = (url, { shallow }) => {
      console.log(
        `App is changing to ${url} ${shallow ? "with" : "without"
        } shallow routing`
      );
    };

    const handleRouteEnd = (url, { shallow }) => {

      // window.mTrack('pageview', { url: '/' + window.location.pathname.split('/')[1] });
      console.log(
        `App is ended to ${url} ${shallow ? "with" : "without"} shallow routing`
      );
    };
    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("routeChangeComplete", handleRouteEnd);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
      router.events.off("routeChangeComplete", handleRouteEnd);
    };
  }, []);

  return (
    <motion.div
      key={router.route}
      initial="pageInitial"
      animate="pageAnimate"
      variants={{
        pageInitial: {
          opacity: router.query.transition ? 0 : 1,
        },
        pageAnimate: {
          opacity: 1,
        },
      }}
    >
      <ErrorBoundary>
        {/* <HeaderContext.Provider value={{
          headerInfo,
          setHeaderInfo
        }}> */}
        <Component
          {...pageProps}
          authorizationParames={authorizationParames}
          baseUrl={isDev ? "" : "https://api.gymclassvr.com"}
          isDev={isDev}
        />
        {/* </HeaderContext.Provider>  */}
      </ErrorBoundary>
    </motion.div>
  );
}

export default MyApp;
